import { render } from "./alarm-history.vue?vue&type=template&id=831b70c8&scoped=true"
import script from "./alarm-history.vue?vue&type=script&lang=js"
export * from "./alarm-history.vue?vue&type=script&lang=js"

import "./alarm-history.vue?vue&type=style&index=0&id=831b70c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831b70c8"]])

export default __exports__